module.exports = __webpack_public_path__ + "1dc83fb1b52389ca7e3d2577fcdc7712.jpg";